import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import { useTheme } from '../../../../../contexts/ThemeContext';

const ThemeToggle = () => {
    const { mode, toggleTheme } = useTheme();

    return (
        <Tooltip title={mode === 'light' ? 'Switch to Dark Mode' : 'Switch to Light Mode'}>
            <IconButton
                onClick={toggleTheme}
                sx={{
                    color: 'text.primary',
                    bgcolor: 'action.hover',
                    '&:hover': {
                        bgcolor: 'action.selected'
                    }
                }}
            >
                {mode === 'light' ? <DarkModeOutlinedIcon /> : <LightModeOutlinedIcon />}
            </IconButton>
        </Tooltip>
    );
};

export default ThemeToggle;
